import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';

import { FeatureModulesService } from '@spartacus/core';

import { COMMON_ACCESSORY_FEATURE } from '../constants';

export const accessoryModuleGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => (
  inject(FeatureModulesService).resolveFeature(COMMON_ACCESSORY_FEATURE).pipe(
    map(() => true)
  )
);
